import React, { useContext } from "react";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import GroupBiorepositoryOps from "../FieldTags/GroupBiorepositoryOps";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const RushOrder = ({ rushOrder, handleChange, pullLists }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOOPS, ROLES.DCT, ROLES.APPROVER]);

    return (
        <div className="planField">
            <GroupBiorepositoryOps />
            <FormControl
                id="rushOrder-field"
                name="rushOrder"
            >
                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                    <FormControlLabel
                        label={pullListLabels.rushOrder}
                        //labelPlacement="start"
                        control={
                            <Checkbox
                                checked={rushOrder === true}
                                onChange={(e) => handleChange("rushOrder", e.target.checked)}
                                disabled={!canEdit}
                            />
                        }
                    />
                </div>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"rushOrder"}/>
        </div>
);
};

export default RushOrder;